import {connect} from 'react-redux';
import {setDefaultView, setCurrentPath} from '../../actions/approvalPage';

export default connect((state, {currentUser}) => ({
    defaultView: state.approval.defaultView,
    supervisorSelect: state.approval.supervisorSelect || (currentUser && currentUser.id)
  }),
  {setDefaultView, setCurrentPath}
);
